/**
 * Keep the full cart page authoritative with Shopify's cart state.
 *
 * Quantity steppers update their input in global.js. On the cart page we
 * submit the cart form after that change so Shopify recalculates line totals,
 * subtotal, minimum order and free-shipping state together. If the cart
 * drawer changes the same cart while this page is open, reload the page so it
 * cannot continue showing stale totals behind the drawer.
 */
(function () {
  var section = document.querySelector('[data-main-cart]');
  if (!section) return;

  var form = section.querySelector('.main-cart__form');
  if (!form) return;

  var submitting = false;
  var submitCart = window.theme.debounce(function () {
    if (submitting) return;
    submitting = true;
    section.setAttribute('aria-busy', 'true');
    HTMLFormElement.prototype.submit.call(form);
  }, 250);

  form.addEventListener('change', function (event) {
    if (!event.target.closest('[data-quantity-field]')) return;
    submitCart();
  });

  document.addEventListener('cart:updated', function (event) {
    if (!event.detail || event.detail.source !== 'drawer') return;
    window.location.reload();
  });
})();
